import React, { Component } from 'react';
import cx from 'classnames';

import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';

import { connect } from 'react-redux';
import { UiActions } from 'state/actions/UiActions';

import uploadFileIcon from 'assets/svg/upload-file.svg';
import uploadWhiteFileIcon from 'assets/svg/upload-file-white.svg';
import instagramIcon from 'assets/svg/social-icons/instagram.svg';
import tiktokIcon from 'assets/svg/social-icons/tiktok.svg';
import youtubeIcon from 'assets/svg/social-icons/youtube.svg';

import { PrimaryPinkButton } from 'components/buttons/PrimaryPinkButton';
import { SecondPinkButton } from 'components/buttons/SecondPinkButton';

import { Modal } from 'components/modal/Modal';
import { AttentionModal } from 'components/glamstar/AttentionModal';

import styles from './styles.module.scss';

export class GlamstarChallangeForm extends Component {
  constructor(props) {
    super(props);

    const { match } = this.props;
    this.campaignId = match.params?.id;
    this.history = this.props.history;

    this.state = {
      urlTiktok: '',
      urlInstagram: '',
      urlYoutube: '',
      videoFile: null,

      showAttentionModal: false,
      showSuccessModal: false,
      sendingChallenge: false,
    };
    this.uploadFileRef = React.createRef();
  }

  onChangeVideo = event => {
    const file = event.target.files[0];

    if (file) {
      const [fileType] = file.type.split('/');
      if (fileType !== 'video') {
        this.props.publishErrorAlert('Formato de vídeo inválido');
        return;
      }

      this.setState({
        videoFile: file,
      });
    }
  };

  handleUploadFile = () => {
    if (!this.uploadFileRef.current) {
      return;
    }

    this.uploadFileRef.current.click();
  };

  handleCloseSuccessModal = () => {
    this.setState({
      showSuccessModal: false,
    });

    this.history.push('/glampartner/glamstar/desafios');
  };

  handleCloseAttentionModal = () => {
    this.setState({
      showAttentionModal: false,
    });
  };

  handleNavigateToChallenges = () => {
    this.history.push('/glampartner/glamstar/desafios');
  };

  onChangeUrl = event => {
    const { name, value } = event.target;

    this.setState({
      [name]: value,
    });
  };

  uploadRequest = async data => {
    const headers = {
      Authorization: this.props.token,
    };
    const uploadUrl = `${process.env.REACT_APP_GB_API_ROOT}${GlamboxEndpoints.Campaign.uploadChallengeFile.url}`;

    return new Promise((resolve, reject) => {
      const _xhr = new XMLHttpRequest();

      _xhr.onload = () => {
        resolve(JSON.parse(_xhr.response));
      };
      _xhr.onerror = _ => {
        reject(_xhr.response);
      };

      _xhr.open('POST', uploadUrl);
      if (Object.keys(headers).length > 0) {
        Object.keys(headers).forEach(key => {
          _xhr.setRequestHeader(key, headers[key]);
        });
      }
      _xhr.send(data);
    });
  };

  buildFormData = () => {
    const { videoFile, urlInstagram, urlTiktok, urlYoutube } = this.state;

    const data = new FormData();
    data.append('fileVideo', videoFile);
    data.append('campaignId', this.campaignId.toString());
    urlInstagram?.trim() !== '' &&
      data.append('urlInstagram', urlInstagram.toString());
    urlTiktok?.trim() !== '' && data.append('urlTikTok', urlTiktok.toString());
    urlYoutube?.trim() !== '' &&
      data.append('urlYouTube', urlYoutube.toString());

    return data;
  };

  sendChallenge = async () => {
    this.props.loaderShow();
    this.setState({
      sendingChallenge: true,
    });

    try {
      const data = this.buildFormData();
      const response = await this.uploadRequest(data);

      if (response.status === 403) {
        throw new Error(response?.message ?? 'Acesso restrito');
      }

      if (response.status === 'BAD_REQUEST') {
        throw new Error(
          response?.message ?? 'Você não pode enviar um novo vídeo'
        );
      }

      this.setState({
        showSuccessModal: true,
      });
    } catch (err) {
      this.props.publishErrorAlert(
        err.message ??
          'Houve um erro ao enviar o desafio. Por favor verifique o tamanho do vídeo (máximo 100MB)'
      );
    } finally {
      this.props.loaderHide();
      this.setState({ sendingChallenge: false });
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const { videoFile, urlTiktok, urlInstagram, urlYoutube, sendingChallenge } =
      this.state;

    if (sendingChallenge) {
      return;
    }

    if (!urlTiktok && !urlInstagram && !urlYoutube) {
      this.props.publishErrorAlert(
        'Você deve colocar o link de pelo menos uma postagem'
      );
      return;
    }

    if (!videoFile) {
      this.props.publishErrorAlert('Você precisa fazer o upload do seu vídeo');
      return;
    }

    this.setState({ showAttentionModal: true });
  };

  componentDidMount() {
    const { location, history } = this.props;
    if (!location.state?.canAccess) {
      history.push('/glampartner/glamstar/desafios');
      return;
    }
  }

  render() {
    const {
      showAttentionModal,
      showSuccessModal,
      sendingChallenge,
      videoFile,
      urlInstagram,
      urlTiktok,
      urlYoutube,
    } = this.state;

    return (
      <div className={styles.container}>
        <main className={styles.hero}>
          <section className={styles.uploadDescription}>
            <div>
              <img src={uploadFileIcon} alt="Envio de arquivo" />
              <h1 className={styles.uploadDescriptionTitle}>
                Bora enviar seu desafio?
              </h1>
            </div>
            <p>
              Anexe nos campos abaixo os links das suas postagens do challenge,
              lembrando que você pode postar em uma rede social ou em todas.
              Vamos somar todo o seu engajamento. E escolha a versão que MAIS
              gostou para fazer o upload do arquivo.
            </p>
          </section>
          <section className={styles.uploadSection}>
            <form className={styles.uploadForm} onSubmit={this.handleSubmit}>
              <h2 className={styles.uploadFormTitle}>Arquivos para Upload</h2>
              <div className={styles.formGroup}>
                <span className={styles.formSubtitle}>
                  <img src={tiktokIcon} alt="Tiktok" />
                  Tiktok
                </span>
                <div className={styles.box}>
                  <div className={styles.innerBox}>
                    <label htmlFor="tiktok">URL Challenge</label>
                    <input
                      className={cx(styles['formInput'], {
                        [styles['formInput--active']]: urlTiktok,
                      })}
                      placeholder="Cole aqui sua URL"
                      type="text"
                      name="urlTiktok"
                      id="urlTiktok"
                      pattern="(http|https:\/\/)?((www|vm|m)\.)?tiktok\.com\/.+"
                      title="Por favor insira uma URL do Tiktok válida."
                      onChange={this.onChangeUrl}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formGroup}>
                <span className={styles.formSubtitle}>
                  <img src={instagramIcon} alt="Instagram" />
                  Instagram
                </span>
                <div className={styles.box}>
                  <div className={styles.innerBox}>
                    <label htmlFor="instagram">URL Challenge</label>
                    <input
                      className={cx(styles['formInput'], {
                        [styles['formInput--active']]: urlInstagram,
                      })}
                      placeholder="Cole aqui sua URL"
                      type="text"
                      name="urlInstagram"
                      id="urlInstagram"
                      pattern="(http|https:\/\/)?(www\.)?instagram\.com\/(?:p|reel|tv)\/([^/?#]+).*"
                      title="Por favor insira uma URL do Instagram válida."
                      onChange={this.onChangeUrl}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formGroup}>
                <span className={styles.formSubtitle}>
                  <img src={youtubeIcon} alt="Youtube" />
                  Youtube
                </span>
                <div className={styles.box}>
                  <div className={styles.innerBox}>
                    <label htmlFor="youtube">URL Challenge</label>
                    <input
                      className={cx(styles['formInput'], {
                        [styles['formInput--active']]: urlYoutube,
                      })}
                      placeholder="Cole aqui sua URL"
                      type="text"
                      name="urlYoutube"
                      id="urlYoutube"
                      pattern="^(http|https:\/\/)?(www\.)?((youtube\.com\/(watch\?v=|shorts\/))|(youtu.be\/))([a-zA-Z0-9\-_\?feature=share])+"
                      title="Por favor insira uma URL do Youtube válida."
                      onChange={this.onChangeUrl}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formGroup}>
                <span className={styles.formSubtitle}>Enviar Vídeo</span>
                <div className={styles.box}>
                  <div className={styles.innerBox}>
                    <input
                      type="file"
                      name="video"
                      id="uploadVideo"
                      accept="video/mp4,video/x-m4v,video/*"
                      onChange={this.onChangeVideo}
                      ref={this.uploadFileRef}
                    />

                    {videoFile?.name && (
                      <span className={styles.videoFileName}>
                        {videoFile?.name}
                      </span>
                    )}
                    <PrimaryPinkButton
                      onClick={this.handleUploadFile}
                      type="button"
                    >
                      <img src={uploadWhiteFileIcon} alt="Enviar arquivo" />
                      Enviar arquivo
                    </PrimaryPinkButton>
                    <small className={styles.videoSize}>
                      <strong className={styles['videoSize__important']}>
                        *
                      </strong>
                      Tamanho máximo (<strong>100MB</strong>)
                    </small>
                  </div>
                </div>
              </div>

              <div className={styles.buttonsAction}>
                <SecondPinkButton
                  type="button"
                  onClick={this.handleNavigateToChallenges}
                >
                  Cancelar
                </SecondPinkButton>
                <PrimaryPinkButton type="submit">
                  {sendingChallenge ? 'Aguarde' : 'Finalizar Challenge'}
                  {sendingChallenge}
                </PrimaryPinkButton>
              </div>
            </form>
          </section>
        </main>

        <Modal
          useDefaultDialog={false}
          visible={showAttentionModal}
          onCloseModal={this.handleCloseAttentionModal}
          showCloseButton={false}
        >
          <AttentionModal
            type="attention"
            confirmBtnText="Entendi, quero finalizar"
            title="Fique atenta, Glamstar!"
            description="Vocês só poderá fazer um envio do seu challenge. Tem certeza que quer finalizar?"
            onCloseModal={this.handleCloseAttentionModal}
            onConfirm={this.sendChallenge}
          />
        </Modal>

        <Modal
          useDefaultDialog={false}
          visible={showSuccessModal}
          onCloseModal={this.handleCloseAttentionModal}
          showCloseButton={false}
        >
          <AttentionModal
            type="success"
            confirmBtnText="Entendi"
            title="Arquivo enviado com sucesso!"
            onCloseModal={this.handleCloseSuccessModal}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state,
  token: state.token.data.Authorization,
});

const mapDispatchToProps = dispatch => ({
  publishSuccessAlert: message => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: message => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
});

GlamstarChallangeForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(GlamstarChallangeForm);
